export function formatProfileName(
  first?: string | null,
  last?: string | null,
  fallback = 'Volunteer',
): string {
  const full = `${first?.trim() ?? ''} ${last?.trim() ?? ''}`.trim();
  return full || fallback;
}
